module.exports = __webpack_public_path__ + "img/37@2x.312ffd98.png";